import React, { useEffect, useRef, useState } from 'react';
import CounterBox from '../components/CounterBox';
import { Col, Container, Row } from 'reactstrap';
import { title } from 'process';
import Button from '../../../components/Button';
import { useNavigate } from 'react-router-dom';
import AboutUsImg from '../../../assets/images/homeAboutus.png';
import StarredImage from './StarredImage';

const counterData = [
  { count: 1037, label: 'Projects Completed' },
  { count: 156, label: 'Qualified Team' },
  { count: 90, label: 'Client Satisfaction', suffix: '%' },
  { count: 23, label: 'Years of experience', suffix: '+' },
];

type AboutSectionProps = {
  title: string;
  subtitle: string;
  isButton?: boolean;
};

const AboutSection: React.FC<AboutSectionProps> = ({ title, subtitle }) => {
  const navigate = useNavigate();
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const [triggerKey, setTriggerKey] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTriggerKey((prev) => prev + 1);
        }
      },
      { threshold: 0.5 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
  interface OurStoryDataTypes {
    paragraphs: string[];
    image: string;
  }
  const ourStoryData: OurStoryDataTypes = {
    paragraphs: [
      'At Legalligence, we’re redefining legal work by combining AI-driven technology with deep legal expertise. Our mission is to empower corporates, legal professionals, and law firms with intelligent, efficient solutions. We’re not just building tools—we’re shaping the future of legal operations. Every product is designed for real-world impact and measurable value.',
      'Our team brings together experienced lawyers and technologists to bridge the gap between law and innovation. With a strong focus on AI, we develop smart platforms that simplify complex legal processes. From contract workflows to compliance tools, we help legal teams work faster, smarter, and with greater confidence.',
    ],
    image: AboutUsImg,
  };

  const { paragraphs, image } = ourStoryData;

  return (
    <section className="section-gap-lg pt-0 aboutSection" ref={sectionRef}>
      <Container>
        <div className={`home-about ourstory-container`}>
          <div className="ourstory-cnt" data-aos="fade-right">
            <h2>
              {title}
              <span>{subtitle}</span>
            </h2>
            <Row className="g-3 g-md-5 g-lg-0 home-about-row">
              <Col lg="5" md="12" data-aos="fade-right">
                <p className="head-gap-lg">{paragraphs[0]}</p>
                <p>{paragraphs[1]}</p>

                <div className="about-btn">
                  <Button label="Know More" onClick={() => navigate('/about')} />
                </div>
              </Col>
              <Col lg="7" md="12" data-aos="fade-left">
                <div className="our-story-img-cnt" data-aos="fade-left">
                  <div className="our-story-img">
                    <StarredImage imageSrc={image} alt={title || 'About Us'} starPosition="right" />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        {/* <div className="counter-aboutus-container">
          {counterData.map((item, index) => (
            <div
              className="count-aboustus-col"
              key={`${triggerKey}-${index}`}
              data-aos="fade-up"
              data-aos-delay={`${index * 250}`}
              data-aos-duration="1200"
            >
              <CounterBox
                count={item.count}
                label={item.label}
                trigger={true}
                suffix={item.suffix}
              />
            </div>
          ))}
        </div> */}
      </Container>
    </section>
  );
};

export default AboutSection;
